import getPopularClients from '../../api/getPopularClients';

/**
 * @typedef {object} Data
 * @property {boolean} loading
 * @property {null | string} error
 * @property {Awaited<ReturnType<typeof getPopularClients>>} clients
 */

/**
 * @typedef {object} Methods
 * @property {() => void} loadClients
 */

/**
 * @typedef {object} Computed
 * @property {boolean} showLoading
 * @property {boolean} showError
 * @property {boolean} showEmpty
 * @property {boolean} showList
 */

/** @type {import('vue/types/options').ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, {}>} */
export const ServiceRequestNewFormPopularClients = {
	data: () => ({
		loading: false,
		error: null,
		clients: [],
	}),
	computed: {
		showLoading: (vm) => vm.loading,
		showError: (vm) => !vm.loading && vm.error,
		showEmpty: (vm) => !vm.loading && vm.clients.length === 0,
		showList: (vm) => !vm.loading && vm.clients.length > 0,
	},
	methods: {
		loadClients() {
			this.loading = true
			this.error = null

			getPopularClients()
				.then((clients) => this.clients = clients)
				.catch(() => this.error = 'Что-то пошло не так...')
				.finally(() => this.loading = false)
		} 
	},
	mounted() {
		this.loadClients()
	},
	render() {
		return (
			<div>
				<p class="service-request-new-form-popular-clients-heading">
					Популярные клиенты
				</p>
				{this.showLoading && (
					<div>
						Загрузка...
					</div>
				)}
				{this.showError && (
					<div>
						{this.error}
					</div>
				)}
				{this.showEmpty && (
					<div>
						Нет клиентов
					</div>
				)}
				{this.showList && (
					<ul class="service-request-new-form-popular-clients-list">
						{this.clients.map((client) => (
							<li>
								<button
									type="button"
									class="service-request-new-form-popular-clients-link"
									vOn:click={() => this.$emit('click', client)}
								>
									{client.NAME}
								</button>
							</li>
						))}
					</ul>
				)}
			</div>
		)
	},
}
